/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-28 15:53:24
 * @LastEditTime: 2022-01-28 20:36:24
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/page/HsbMarketPlatform/rule/detail.jsx
 */

import { Button, Modal, Table } from 'antd';
import React, { useState } from 'react'
import { dicRecvCertType, mapMerchantCardType } from '../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../components/Custom';
import DetailTitle from '../../../components/DetailTitle';
import ModalScrollContainer from '../../../components/ModalScrollContainer';
import { fetchHSBMarketPlatformRuleGet } from '../../../services/HSBMarketPlatform';
import { findDict, formatTime } from '../../../utils';

const HsbMarketPlatformRuleDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postRuleGet(id)
    }
    const close = () => {
        setVisible(false)
        setDetailData([])
    }

    const mapInfoClrgMtdcd = [
        { title: '按金额', value: "4" },
        { title: '按比例', value: "5" },
    ]

    const mapClrgMode = [
        { title: '翻盘式', value: "1" },
        { title: '滚动式', value: "2" },
        { title: '时间自定义式', value: "3" },
    ]

    const mapClrgMtdcd = [
        { title: '固定金额', value: "1" },
        { title: '固定比例', value: "2" },
        { title: '先固定金额再比例', value: "3" },
    ]

    const postRuleGet = (id) => {
        fetchHSBMarketPlatformRuleGet({id}).then(res => {
            setDetailData(res)
        })
    }
    const rulesMemberColumns = [
        { title: '顺序号', dataIndex: 'seqNo', },
        { title: '清算方式代码', dataIndex: 'clrgMtdcd', render: (text) => {
                return findDict(mapInfoClrgMtdcd, text).title
            }},
        { title: '金额', dataIndex: 'amt',render: (text) => {
                if(text!=null && text!=''){
                    return text;
                }else{
                    return "/";
                }
            }},
        { title: '清算比例', dataIndex: 'clrgPctg',render: (text) => {
            if(text!=null && text!=''){
                return text+"%";
            }else{
                return "/";
            }
            }},
        { title: '同步时间', dataIndex: 'updateTime', render: (text) => formatTime(text, 'YYYY-MM-DD HH:mm')}
    ]

    const mapSubAccCyc = [
        { title: '日', value: "1" },
        { title: '月', value: "2" },
        { title: '月末', value: "3" },

    ]

    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="对账规则" 
            width={650} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
                    <CustomRow >
                        <CustomCol label="市场名称" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.mktNm}</span>
                        </CustomCol>
                        <CustomCol label="市场编号" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.mktId}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="规则名称" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.ruleNm}</span>
                        </CustomCol>
                        <CustomCol label="清算模式" required={false}>
                            <span style={{ paddingLeft:6 }}>{findDict( mapClrgMode, detailData.clrgMode).title }</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="清算后延天数" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.clrgDlayDys}</span>
                        </CustomCol>
                        <CustomCol label="清算方式代码" required={false}>
                            <span style={{ paddingLeft:6 }}>{findDict( mapClrgMtdcd, detailData.clrgMtdcd).title }</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                
                        <CustomCol label="清算规则编号" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.clrgRuleId}</span>
                        </CustomCol>
                    
                        <CustomCol label="分账周期" required={false}>
                            <span style={{ paddingLeft:6 }}>{findDict( mapSubAccCyc, detailData.subAccCyc).title }</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>  

                        <CustomCol label="生效日期 " required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.efdt}</span>
                        </CustomCol>
                        <CustomCol label="失效日期" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.expdt}</span>
                        </CustomCol>
                    </CustomRow>

                    <CustomRow divider>
                        <CustomCol label="规则描述" required={false}>
                            <span style={{ paddingLeft:6 }}>{detailData.ruleDsc}</span>
                        </CustomCol>

                    </CustomRow>

                    <DetailTitle title="参与方" />
                    <Table 
                        columns={rulesMemberColumns}
                        dataSource={detailData.rulesMemberList}
                    />
                    
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default HsbMarketPlatformRuleDetail


// WEBPACK FOOTER //
// ./src/page/HsbMarketPlatform/rule/detail.jsx